export default "__VITE_ASSET__DM805Rhc__"